<template>
  <div class="basicPortContent">
    <!--loading-->
    <loading v-show="isLoading" />
    <!--el-from-->
    <div class="serachBack">
      <el-form
        ref="ruleForm"
        size="mini"
        label-position="right"
        :model="ruleForm"
      >
        <div class="searhContent">
          <el-form-item prop="str" style="display: inline-block; width: 200px">
            <el-input
              v-model="ruleForm.str"
              placeholder="请输入搜索内容"
              maxlength="100"
              @input="handleInputClick"
            />
          </el-form-item>
          <span
            v-if="shipUpdaterLastExecutionStat.executionTime"
            class="downloadShipUpdaterLog"
            :class="{
              'update-error': shipUpdaterLastExecutionStat.status === 'error',
              'update-warn': shipUpdaterLastExecutionStat.status === 'warn',
            }"
            :title="shipUpdaterLastExecutionStat.title"
            @click="downloadShipUpdaterLog"
          >
            上次更新时间: {{ shipUpdaterLastExecutionStat.executionTime }}</span
          >
          <!-- <el-button size="small" class="clickColor butn" @click="handleAddClick">新增</el-button>
                    <el-button size="small" class="clickColor butnDele" @click="delectRoute">删除</el-button> -->

          <el-button
            size="small"
            :disabled="newshipv2Dialog"
            class="butn"
            style="margin-left: 10px"
            icon="el-icon-office-building"
            @click="openNewShipV2"
          />

          <el-button
            size="small"
            class="clickColor butn"
            :loading="triggerUpdating"
            @click="triggerUpdateShip"
          >
            触发更新
          </el-button>

          <el-button
            v-if="shipUpdaterLastExecutionStat.isupdate"
            size="small"
            class="clickColor butn"
            @click="searchList()"
          >
            刷新
          </el-button>
        </div>
        <div style="clear: both"></div>
      </el-form>
    </div>
    <!--el-table-->
    <div class="tablePage">
      <el-table
        ref="table"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#3bafda',
          color: '#ffffff',
          fontSize: '12px',
        }"
        :row-class-name="tabRowClassName"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="mmsi"
          label="MMSI"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="100"
        />
        <el-table-column
          prop="nameEn"
          label="船名_AIS"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        />
        <el-table-column
          prop="vesselNameDoc"
          label="船名_档案"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        />
        <el-table-column
          prop="imo"
          label="IMO"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="100"
        />
        <el-table-column
          prop="shipOwnerCn"
          label="运营方"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="140"
        >
          <template slot-scope="scope">
            <div class="sel-el">
              <el-select
                v-model="scope.row.shipOwnerCn2"
                filterable
                clearable
                remote
                :placeholder="scope.row.shipOwnerCn"
                :remote-method="remoteShipping"
                :loading="remoteing"
                @focus="() => remoteShipping()"
                @change="() => updateShipOwner(scope.row)"
                @clear="() => updateShipOwner(scope.row)"
              >
                <el-option
                  v-for="ship of shippings"
                  :key="ship.code"
                  :value="ship.code"
                >
                  {{ ship.nameScn }}({{ ship.code }})
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="category"
          label="类别"
          align="left"
          show-overflow-tooltip
          min-width="140"
        >
          <template slot-scope="scope">
            <div class="sel-el">
              <el-select
                v-model="scope.row.category"
                clearable
                @change="() => updateCategory(scope.row)"
                @clear="() => updateCategory(scope.row)"
              >
                <el-option
                  v-for="c of categories"
                  :key="c.id"
                  :value="c.id"
                  :label="c.value"
                >
                  {{ c.value }}
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="142"
        />

        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="142"
        />

        <el-table-column
          prop="updateUser"
          label="操作人"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="100"
        />
        <el-table-column
          prop="opTime"
          label="操作时间"
          align="left"
          :show-overflow-tooltip="true"
          :sortable="sortableState"
          :filters="[]"
          min-width="142"
        />

        <el-table-column
          prop="reanalyseUpdateTime"
          label="分析时间"
          align="left"
          :show-overflow-tooltip="true"
          min-width="180"
        >
          <div slot-scope="scope">
            <span style="margin-right: 10px">{{
              scope.row.reanalyseUpdateTime || '空'
            }}</span>
            <el-button
              type="text"
              size="mini"
              :loading="scope.row.reanalysing"
              :disabled="!scope.row.mmsi || scope.row.reanalysedisabled"
              @click="reanalyse(scope.row)"
            >
              分析
            </el-button>
          </div>
        </el-table-column>

        <template slot="empty">
          <noData />
        </template>
      </el-table>
      <!--分页-->
      <ThePagination
        ref="refPagination"
        :page-number="pageNumber"
        :attribute="paginationAttribute"
        class="refPagination"
      />
    </div>
    <!-- <el-dialog class="shipMent" :visible.sync="shipMent" v-if="shipMent" ref="shipMent" width="1100px"
            append-to-body top="50px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <basicShipAdd :shipManag="shipManag" @closeShipInfor="handleClose" @updatShip="updatShip"
                :vesselId="vesselId" ref="basicShipAdd">
            </basicShipAdd>
        </el-dialog> -->

    <new-ship-v2 :visible.sync="newshipv2Dialog" />
  </div>
</template>

<script>
import { debounce } from 'lodash'
import basicShipAdd from './basicShipAdd.vue'
import ThePagination from '@/components/ThePagination/ThePagination.vue'
import loading from '@/components/Loading/outLoading.vue'
import noData from '@/components/noData/index.vue'
import NewShipV2 from './NewShipV2.vue'
export default {
  components: {
    ThePagination,
    loading,
    basicShipAdd,
    noData,
    'new-ship-v2': NewShipV2,
  },
  data() {
    return {
      newshipv2Dialog: false,
      shipUpdaterLastExecutionStat: {},
      triggerUpdating: false,
      categories: [
        {
          id: 1,
          value: '驳船',
        },
        {
          id: 2,
          value: '国际集装箱船',
        },
      ],
      shippings: [],
      remoteing: false,
      matched: '',
      isLoading: true,
      sortableState: true,
      shipMent: false,
      shipManag: '',
      vesselId: '',
      ruleForm: {
        str: '',
      },
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      // 引用 ThePagination组件
      refPagination: {},
      paginationAttribute: {
        handleChange: this.handleChange,
      },
      //分页默认状态
      pageNumber: -1,
      page: {
        // 当前页数
        pageNo: 1,
        // 每页默认显示条数
        pageSize: 10,
        // 总条数
        total: 0,
      },
      handleSelection: [],
      companyNameList: [],
    }
  },
  async mounted() {
    this.matched = this.$route.matched
    this.searchList()

    this.$bus.on('clickMenu', content => {
      if (
        Math.ceil(this.tableData.length / this.page.pageSize) < this.page.pageNo
      ) {
        this.page.pageNo = 1
        this.pageNumber = 1
      }
      this.$refs.table.clearSort()
      this.ruleForm.str = ''
      this.searchList()
    })

    this.$emit('startloop')
  },

  destroyed() {
    this.$bus.off('clickMenu')
    this.$emit('stoploop')
  },

  activated() {
    this.$emit('startloop')
  },

  deactivated() {
    this.$emit('stoploop')
  },

  created() {
    this.handleInputClick = debounce(this.handleInputClick, 500)

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    let state = 0,
      nextfunc,
      basefunc = () => this.$emit('nextloop')

    const _checkLastExecutionStat = async (count, ms) => {
      state = 1
      while (count-- && state > 0) {
        const stat = await this.getShipUpdaterLastExecutionStat()
        if (stat === true || stat === 'error') {
          break
        }

        while (ms > 0 && state > 0) {
          let k = Math.min(2000, ms)
          await sleep(k)
          ms -= k
        }
      }
      state = 0
    }

    this.$on('nextloop', (count, ms) => {
      _checkLastExecutionStat(count || 1, ms || 30000).then(() => {
        if (typeof nextfunc === 'function') {
          nextfunc()
          nextfunc = null
        } else {
          const hours = new Date().getHours()
          if (hours >= 20 || hours <= 6) {
            return this.$emit('nextloop', 1, 1000 * 60 * 60)
          }
          basefunc()
        }
      })
    })

    this.$on('startloop', () => {
      this.$emit('nextloop')
    })

    this.$on('stoploop', () => {
      state = 0
      nextfunc = () => null
    })

    this.$on('triggerUpdateShipSuccess', () => {
      state = 0
      nextfunc = () => this.$emit('nextloop', 6, 10000)
    })
  },
  methods: {
    async reanalyse(row) {
      this.$set(row, 'reanalysing', true)

      try {
        const resp = await this.$axios.post(
          this.commonJs.localUrl + `/schedules/baseVessel/reanalyse`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
            params: {
              mmsi: row.mmsi,
            },
          }
        )

        if (resp.data.status === 1) {
          this.$message.success(
            `已添加至队列中，预计${resp.data.content}分钟后更新`
          )
          this.$set(row, 'reanalysedisabled', true)
        } else {
          this.$message.error(resp.data.message || '分析失败')
        }
      } finally {
        this.$set(row, 'reanalysing', false)
      }
    },

    openNewShipV2() {
      this.newshipv2Dialog = true
    },

    async downloadShipUpdaterLog() {
      if (
        this.shipUpdaterLastExecutionStat &&
        this.shipUpdaterLastExecutionStat.logPath
      ) {
        this.isLoading = true
        try {
          const resp = await this.$axios.get(
            this.commonJs.localUrl +
              `/schedules/baseVessel/downloadShipUpdaterLog`,
            {
              headers: {
                Authorization: `Bearer ${this.getAuthorization()}`,
                AccessToken: this.getCookie('token'),
              },
              params: {
                log: this.shipUpdaterLastExecutionStat.logPath,
              },
              responseType: 'blob',
            }
          )

          let url = window.URL.createObjectURL(resp.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          let contentDisposition = resp.headers['content-disposition']
          console.log('contentDisposition = ' + contentDisposition)
          if (contentDisposition) {
            let fileName = contentDisposition.split('filename=')
            link.setAttribute('download', fileName[1])
            document.body.appendChild(link)
            link.click()
          } else {
            this.$message.error('暂无数据')
          }
        } finally {
          this.isLoading = false
        }
      }
    },

    async getShipUpdaterLastExecutionStat() {
      try {
        const executionTime = this.shipUpdaterLastExecutionStat.executionTime

        const resp = await this.$axios.get(
          this.commonJs.localUrl +
            `/schedules/baseVessel/shipUpdaterLastExecutionStat`,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )

        if (resp.data.status === 1) {
          this.shipUpdaterLastExecutionStat = resp.data.content || {}

          let title = '下载船舶更新器日志'

          if (
            this.shipUpdaterLastExecutionStat.errorcount ||
            this.shipUpdaterLastExecutionStat.exception
          ) {
            const { errorcount = 0, exception = 0 } =
              this.shipUpdaterLastExecutionStat

            this.shipUpdaterLastExecutionStat.status = 'error'
            title += `, 错误: ${errorcount + exception}个`
          } else if (this.shipUpdaterLastExecutionStat.warncount) {
            this.shipUpdaterLastExecutionStat.status = 'warn'
            title += `, 提醒: ${this.shipUpdaterLastExecutionStat.warncount}个`
          }

          this.shipUpdaterLastExecutionStat.title = title

          if (
            executionTime &&
            this.shipUpdaterLastExecutionStat.executionTime !== executionTime
          ) {
            this.shipUpdaterLastExecutionStat.isupdate = true
            this.$message.success('船舶已更新，请刷新获取最新列表')
            return true
          }
        }
      } catch (e) {
        return 'error'
      }
    },

    async triggerUpdateShip() {
      this.triggerUpdating = true

      try {
        const resp = await this.$axios.post(
          this.commonJs.localUrl + `/schedules/baseVessel/triggerUpdateShip`,
          null,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        if (resp.data.status === 1) {
          const data = resp.data.content || {}
          if (typeof data.expire === 'number') {
            this.$message.warning(
              `更新失败; ${data.uname} 于 ${data.time} 触发过更新, 请5分钟后重试!`
            )
          } else {
            this.$message.success('更新成功，请稍后更新刷新页面')

            this.$emit('triggerUpdateShipSuccess')
          }
        } else {
          this.$message.error('更新失败; ' + resp.data.message || '')
        }
      } finally {
        this.triggerUpdating = false
      }
    },

    async remoteShipping(content) {
      this.remoteing = true
      try {
        const resp = await this.$axios.get(
          this.commonJs.localUrl + `/schedules/baseVessel/queryShipping`,
          {
            params: {
              content: content || '',
            },
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )
        this.shippings = resp.data.content || []
      } finally {
        this.remoteing = false
      }
    },

    async updateCategory(row) {
      this.isLoading = true
      try {
        const resp = await this.$axios.post(
          this.commonJs.localUrl + `/schedules/baseVessel/updateCategory`,
          null,
          {
            params: {
              id: row.id,
              category: row.category || 0,
            },
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )

        if (resp.data.status !== 1) {
          this.$message.error('修改失败')
        } else {
          await this.searchList()
        }
      } finally {
        this.isLoading = false
      }
    },

    async updateShipOwner(row) {
      if (row.shipOwnerCn2 === row.shipOwnerCn) {
        return
      }

      this.isLoading = true
      try {
        const resp = await this.$axios.post(
          this.commonJs.localUrl + `/schedules/baseVessel/updateShipOwner`,
          null,
          {
            params: {
              id: row.id,
              shipOwner: row.shipOwnerCn2,
            },
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
          }
        )

        if (resp.data.status !== 1) {
          this.$message.error('修改失败')
          this.$set(row, 'shipOwnerCn2', '')
        } else {
          await this.searchList()
        }
      } finally {
        this.isLoading = false
      }
    },

    //输入查询列表
    handleInputClick(value) {
      if (
        Math.ceil(this.tableData.length / this.page.pageSize) < this.page.pageNo
      ) {
        this.page.pageNo = 1
        this.pageNumber = 1
      }
      this.isLoading = true
      this.$refs.table.clearSort()
      this.shipUpdaterLastExecutionStat.isupdate = false
      this.$axios
        .get(this.commonJs.localUrl + `/schedules/baseVessel/list`, {
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
            AccessToken: this.getCookie('token'),
          },
          params: {
            str: value,
            pageNumber: this.page.pageNo,
            pageSize: this.page.pageSize,
          },
        })
        .then(res => {
          if (res.data.status == 1) {
            const data = res.data.content || []
            data.forEach(it => {
              it.shipOwnerCn2 = it.shipOwnerCn
              it.category2 = it.category
            })
            this.tableData = data
            this.$refs.refPagination.page.total = res.data.total
            this.$refs.refPagination.changeValue()
            this.isLoading = false
          } else {
            this.$message({
              type: 'error',
              message: '数据加载失败 请重新加载页面',
            })
          }
        })
    },
    //搜索 (页面初始化)
    async searchList(reload) {
      this.isLoading = true
      this.$refs.table.clearSort()
      try {
        this.shipUpdaterLastExecutionStat.isupdate = false
        const res = await this.$axios.get(
          this.commonJs.localUrl + `/schedules/baseVessel/list`,
          {
            headers: {
              Authorization: `Bearer ${this.getAuthorization()}`,
              AccessToken: this.getCookie('token'),
            },
            params: {
              pageNumber: this.page.pageNo,
              pageSize: this.page.pageSize,
              str: this.ruleForm.str || '',
            },
          }
        )

        if (res.data.status == 1) {
          if (res.data.content !== '') {
            if (res.data.content.length <= 0) {
              this.tableData = []
              if (this.$refs.refPagination) {
                this.$refs.refPagination.page.total = res.data.total
                this.$refs.refPagination.changeValue()
              }
            } else {
              if (res.data.status == 1) {
                const data = res.data.content || []
                data.forEach(it => {
                  it.shipOwnerCn2 = it.shipOwnerCn
                  it.category2 = it.category
                })
                this.tableData = data
                if (this.$refs.refPagination) {
                  this.$refs.refPagination.page.total = res.data.total
                  this.$refs.refPagination.changeValue()
                }
              }
              if (this.$refs.refPagination) {
                if (
                  Math.ceil(
                    this.$refs.refPagination.page.total / this.page.pageSize
                  ) < this.page.pageNo
                ) {
                  this.$refs.refPagination.handleCurrentChange(1)
                }
              }
            }
          }
          if (reload == 'upda') {
            this.$message({
              type: 'success',
              message: '状态修改成功',
            })
          } else if (reload == 'delect') {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
          }
        } else if (res.data.status == 0) {
          this.$message({
            type: 'error',
            message: '数据加载失败 请重新加载页面',
          })
        }
      } finally {
        this.isLoading = false
      }
    },
    //给分页传的属性
    handleChange(params) {
      this.isLoading = true
      this.page.pageSize = params.pageSize
      this.page.pageNo = params.pageNo
      this.searchList()
      this.pageNumber = -1
    },
    //表格的斑马线
    tabRowClassName({ row, rowIndex }) {
      row.index = rowIndex
      let index = rowIndex + 1
      if (index % 2 !== 0) {
        return 'warning-row'
      }
    },
    //新增
    handleAddClick() {
      this.shipMent = true
      this.shipManag = '新增'
    },
    //全选
    handleSelectionChange(val) {
      this.handleSelection = val
    },
    //删除
    delectRoute() {
      var val = this.handleSelection
      if (val.length <= 0) {
        this.$message({
          type: 'error',
          message: '请选择一条或者多条删除',
        })
        return
      }
      this.$confirm(this.commonJs.confirm_delete, '', {
        cancelButtonClass: 'btnCustomCencel',
        confirmButtonClass: 'btnCustomSubmit',
        customClass: 'customClass',
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.isLoading = true
          var that = this
          var delectRouteList = []
          for (let i = 0; i < val.length; i++) {
            delectRouteList.push(val[i].id)
          }
          var ids = delectRouteList.join(',')
          this.$axios
            .get(
              this.commonJs.localUrl +
                `/schedules/baseVessel/delete?ids=${ids}`,
              {
                headers: {
                  Authorization: `Bearer ${this.getAuthorization()}`,
                  AccessToken: this.getCookie('token').replace('Bearer', 'Jwt'),
                },
              }
            )
            .then(res => {
              if (res.data.status == 1) {
                that.searchList('delect')
              } else {
                this.$message({
                  type: 'error',
                  message: '删除失败',
                })
                that.isLoading = false
              }
            })
        })
        .catch(_ => {})
    },
    //关闭事件
    handleClose() {
      this.shipMent = false
    },
    updatShip() {
      this.searchList()
    },
    //双击列表行
    currentChange(row) {
      this.shipMent = true
      this.shipManag = '修改'
      this.vesselId = row.id
    },
  },
}
</script>

<style lang="scss" scoped>
.downloadShipUpdaterLog {
  color: #333;
  font-size: 14px;
  margin-left: 20px;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  &.update-error {
    color: #f56c6c;
  }

  &.update-warn {
    color: #e6a23c;
  }
}

::v-deep.el-row .el-col:nth-last-of-type(1) {
  margin-right: 0;
}

::v-deep .el-col {
  margin-right: 20px;
}

::v-deep .refPagination input {
  width: 100px !important;
}

::v-deep.el-table th,
::v-deep.el-table tr {
  height: 30px;
}

::v-deep.el-table th {
  height: 30px;
  padding: 0;
}

::v-deep.el-table__empty-text {
  width: 100%;
}

::v-deep.el-table .cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep.el-table .caret-wrapper {
  height: 23px;
}

::v-deep.el-table .sort-caret.ascending {
  top: 0px;
}

::v-deep.el-table .sort-caret.descending {
  bottom: 1px;
}

.tablePage ::v-deep.el-icon-arrow-down::before {
  color: red;
  display: none;
  margin-left: -10px;
  height: 0;
}

::v-deep.el-table__column-filter-trigger {
  width: 0;
  height: 0;
}

::v-deep .el-table .warning-row {
  background: rgba(241, 245, 247, 1) !important;
}

::v-deep .el-table .warning-row:hover {
  background: rgba(241, 245, 247, 1);
}

.shipMent {
  overflow: hidden;
}

.basicPortContent {
  position: relative;
  overflow: hidden;
  padding: 20px 20px 20px 20px;
  overflow: hidden;

  .serachBack {
    background-color: #fff;
    padding: 20px 20px 0px 20px;
    position: relative;
  }

  .tablePage {
    background-color: #fff;
    padding: 0px 20px 20px 20px;
  }

  .refPagination {
    width: 100%;
    background-color: #fff;
  }
}

.contentLeft {
  float: left;
  width: 90%;
}

.contenRight {
  position: absolute;
  right: 20px;
  bottom: 5px;
}

.serachBtn {
  padding: 9px 35px;
  color: #fff;
  background-color: rgba(4, 153, 255, 1);
  margin-bottom: 10px;
  border: 1px solid #3bafda;
}

.clickColor {
  background-color: #fff;
  padding: 9px 27px;
  margin-right: 10px;
}

.butn {
  margin-right: 0;
  background-color: #ff9000;
  color: #fff;
  float: right;
  margin-bottom: 20px;
}

.butnDele {
  margin-right: 10px;
  border: 1px solid #ff0000;
  color: #ff0000;
  padding: 9px 35px;
  float: right;
  margin-bottom: 20px;
}

.sel-el {
  overflow: hidden;
  width: 100%;
  height: 28px;
}

.sel-el ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 10px;
}

.sel-el ::v-deep .el-input__icon {
  line-height: 28px;
}

.sel-el ::v-deep .el-input__suffix {
  right: 0;
}
</style>
